module.exports = __webpack_public_path__ + "src/static/measurement-guide.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/static/measurement-guide.pdf
// module id = 601
// module chunks = 0